import { createSelector } from '@reduxjs/toolkit';
import { getResponderDisplayData } from '../../../responders/selectors/getResponderDisplayData';
const getStoredPreviewText = state => state.newMessagePreviewPopup.previewText;
const getStoredHasAttachment = state => state.newMessagePreviewPopup.hasAttachment;
export const getNewMessagePreviewPopupData = createSelector([getStoredPreviewText, getStoredHasAttachment, getResponderDisplayData], (previewText, hasAttachment, agentData) => {
  if (!previewText && !hasAttachment) return;
  return Object.assign({}, agentData, {
    messagePreviewText: previewText !== null && previewText !== void 0 ? previewText : '',
    hasAttachment
  });
});